import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function App() {
  const navigate = useNavigate();

  function enter() {
    console.log('enter');
    navigate('/random');
  }

  return (
    <div className="App w-full flex flex-col justify-center items-center">
    <div className="flex flex-col justify-center items-center w-10/12">
      <img className="w-8/12" src="images/qoheleth.jpg" alt="" />
      <br/>
      <hr/>
      <div>
      The words of the Preacher, the son of David, king in Jerusalem.
      Vanity of vanities, saith the Preacher, vanity of vanities; all is vanity.
      What profit hath a man of all his labour which he taketh under the sun?
      One generation passeth away, and another generation cometh: but the earth abideth for ever.
      The sun also ariseth, and the sun goeth down, and hasteth to his place where he arose.
      The wind goeth toward the south, and turneth about unto the north; it whirleth about continually, and the wind returneth again according to his circuits.
      All the rivers run into the sea; yet the sea is not full; unto the place from whence the rivers come, thither they return again.
      All things are full of labour; man cannot utter it: the eye is not satisfied with seeing, nor the ear filled with hearing.
      The thing that hath been, it is that which shall be; and that which is done is that which shall be done: and there is no new thing under the sun.
      Is there any thing whereof it may be said, See, this is new? It hath been already of old time, which was before us.
      There is no remembrance of former things; neither shall there be any remembrance of things that are to come with those that shall come after.
      </div>
      <br/>
      <hr/>
      <br/>
      <span className='cursor-pointer' onClick={()=>enter()}>
      <img src="/images/enter.jpg" alt="" />
      </span>
      </div>
    </div>
  );
}
